import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { api, Company } from '../api';
import { ErrorBox, useAsync } from '../components/ui';
import { CompanyForm, CompanyInput } from './CompanyForm';

const PAGE = 50;

export function CompaniesPage() {
  const [q, setQ] = useState('');
  const [offset, setOffset] = useState(0);
  const [data, setData] = useState<{ items: Company[]; total: number } | null>(null);
  const [creating, setCreating] = useState(false);
  const list = useAsync();
  const create = useAsync();
  const nav = useNavigate();

  useEffect(() => {
    const t = setTimeout(() => list.run(async () => setData(await api(`/companies?query=${encodeURIComponent(q)}&limit=${PAGE}&offset=${offset}`))), 200);
    return () => clearTimeout(t);
  }, [q, offset]);

  const submit = async (v: CompanyInput) => {
    const c = await create.run(() => api<Company>('/companies', { method: 'POST', body: v }));
    if (c) nav(`/cegek/${c.id}`);
  };

  return (
    <div>
      <div className="page-head">
        <h2>Cégek</h2>
        <input className="search" placeholder="Keresés név vagy weboldal szerint…" value={q} onChange={(e) => { setQ(e.target.value); setOffset(0); }} />
        <button onClick={() => setCreating(true)}>Új cég</button>
      </div>
      {creating && (
        <section className="card">
          <h3>Új cég</h3>
          <CompanyForm onSubmit={submit} onCancel={() => { setCreating(false); create.setError(null); }} error={create.error} busy={create.busy} />
          {(create.error as any)?.details?.duplicate_of && <p><Link to={`/cegek/${(create.error as any).details.duplicate_of}`}>A meglévő cég megnyitása →</Link></p>}
        </section>
      )}
      <ErrorBox error={list.error} />
      <table className="list">
        <thead><tr><th>Név</th><th>Adószám</th><th>Település</th><th>Címkék</th><th className="num">Kontakt</th></tr></thead>
        <tbody>
          {data?.items.map((c) => (
            <tr key={c.id} onClick={() => nav(`/cegek/${c.id}`)}>
              <td><Link to={`/cegek/${c.id}`}>{c.name}</Link>{c.internal_entity_id && <span className="badge">saját cég</span>}</td>
              <td>{c.tax_number ?? '–'}</td>
              <td>{c.address?.city ?? '–'}</td>
              <td>{c.tags.map((t) => <span key={t} className="tag">{t}</span>)}</td>
              <td className="num">{c.contact_count ?? 0}</td>
            </tr>
          ))}
          {data && data.items.length === 0 && <tr><td colSpan={5} className="muted">Nincs találat.</td></tr>}
        </tbody>
      </table>
      {data && data.total > PAGE && (
        <div className="pager">
          <button className="secondary" disabled={offset === 0} onClick={() => setOffset(Math.max(0, offset - PAGE))}>← Előző</button>
          <span>{offset + 1}–{Math.min(offset + PAGE, data.total)} / {data.total}</span>
          <button className="secondary" disabled={offset + PAGE >= data.total} onClick={() => setOffset(offset + PAGE)}>Következő →</button>
        </div>
      )}
    </div>
  );
}
